import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'codeName',
})
export class CodeNamePipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return value;

    // Divide a string em palavras
    const words = value.split(' ');

    if (words.length < 2) return value; // Se houver apenas uma palavra, retorne a string original

    // Pega a primeira e a última palavra
    const firstWord = words[0];
    const lastWord = words[words.length - 1];

    return `${firstWord[0]}${lastWord[0]}`;
  }

}
